

/// <reference path="DBMappingEntity.ts" />

// Generated class DBMappingEntityClient_ManagedObject

class DBMappingEntityClient_ManagedObject extends DBMappingEntity
{
}
